import { Messages } from "../modules/messages";

export const MessagesPage = () => {
  return <Messages />;
};
